/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyExternalSystem
 */
export interface WriteOnlyExternalSystem {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystem
     */
    label: string;
}

export function WriteOnlyExternalSystemFromJSON(json: any): WriteOnlyExternalSystem {
    return WriteOnlyExternalSystemFromJSONTyped(json, false);
}

export function WriteOnlyExternalSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyExternalSystem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'label': json['label'],
    };
}

export function WriteOnlyExternalSystemToJSON(value?: WriteOnlyExternalSystem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
    };
}


